/**
 * Утилиты для управления согласием пользователя
 */

const CONSENT_STORAGE_KEY = "photai_consent_accepted";
const CONSENT_VERSION_KEY = "photai_consent_version";
const CURRENT_CONSENT_VERSION = "1.0.0"; // Версия политики конфиденциальности

/**
 * Проверяет, принял ли пользователь условия политики конфиденциальности
 */
export const hasConsent = (): boolean => {
  if (typeof window === "undefined") return false;

  const accepted = localStorage.getItem(CONSENT_STORAGE_KEY);
  const version = localStorage.getItem(CONSENT_VERSION_KEY);

  // Если согласие принято и версия совпадает
  return accepted === "true" && version === CURRENT_CONSENT_VERSION;
};

/**
 * Сохраняет согласие пользователя
 */
export const setConsent = (accepted: boolean): void => {
  if (typeof window === "undefined") return;

  if (accepted) {
    localStorage.setItem(CONSENT_STORAGE_KEY, "true");
    localStorage.setItem(CONSENT_VERSION_KEY, CURRENT_CONSENT_VERSION);
  } else {
    localStorage.removeItem(CONSENT_STORAGE_KEY);
    localStorage.removeItem(CONSENT_VERSION_KEY);
  }
};

/**
 * Сбрасывает согласие (для тестирования или при обновлении политики)
 */
export const resetConsent = (): void => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(CONSENT_STORAGE_KEY);
  localStorage.removeItem(CONSENT_VERSION_KEY);
};
